import { useForm } from "react-hook-form";
import { FormInput } from "../../../components/ui-lib/form/FormInput";
import classNames from "classnames";
import { ComponentStyles } from "../../../helpers/constants/styles";

export type TeacherRegisterFormFields = {
  email: string;
  name: string;
  lastname: string;
  password: string;
  confirmPassword: string;
};

function TeacherRegisterForm({
  onSubmit,
}: {
  onSubmit: (data: TeacherRegisterFormFields) => void;
}) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm<TeacherRegisterFormFields>({ mode: "onChange" });

  const _onSubmit = handleSubmit((data) => {
    onSubmit(data);
  });

  return (
    <form onSubmit={_onSubmit} className="space-y-4">
      <FormInput
        className="mt-2"
        id="email"
        type="text"
        name="email"
        label="Email"
        placeholder="Email"
        register={register}
        rules={{
          required: "Email muss angegeben werden.",
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
            message: "Ungültige Email-Adresse",
          },
          maxLength: 100,
        }}
        errors={errors}
      ></FormInput>
      <FormInput
        className="mt-2"
        id="name"
        type="text"
        name="name"
        label="Vorname"
        placeholder="Vorname"
        register={register}
        rules={{
          required: "Vorname muss angegeben werden.",
          maxLength: 100,
        }}
        errors={errors}
      ></FormInput>
      <FormInput
        className="mt-2"
        id="lastname"
        type="text"
        name="lastname"
        label="Nachname"
        placeholder="Nachname"
        register={register}
        rules={{
          required: "Nachname muss angegeben werden.",
          maxLength: 100,
        }}
        errors={errors}
      ></FormInput>
      <FormInput
        className="mt-2"
        id="password"
        type="password"
        name="password"
        label="Passwort"
        placeholder="Passwort"
        register={register}
        rules={{
          required: "Passwort muss angegeben werden.",
          maxLength: 100,
        }}
        errors={errors}
      ></FormInput>
      <FormInput
        className="mt-2"
        id="confirmPassword"
        type="password"
        name="confirmPassword"
        label="Passwort bestätigen"
        placeholder="Passwort bestätigen"
        register={register}
        rules={{
          required: "Passwort bestätigen muss angegeben werden.",
          validate: (value) =>
            value === watch("password") || "Passwörter stimmen nicht überein.",
          maxLength: 100,
        }}
        errors={errors}
      ></FormInput>
      <button
        type="submit"
        className={classNames(
          ComponentStyles["primary"],
          "block w-full px-10 md:ml-auto md:w-auto",
        )}
      >
        Registrieren
      </button>
    </form>
  );
}

export default TeacherRegisterForm;
